export const inputType = {type: 'bokeh-file' as const};
